























































































































































































































































































































import Vue from 'vue'
import { hexToRgba } from '@/services/hex-to-rgba'
import { InsertAdressVorgabenPayload, UpdateAdressVorgabenPayload } from '@/types/payload'
import { GET_SELECTED_UI_LANGUAGE } from '@/store/getter-types'
import { Department } from '@/model/companyStructure/Department'
import { PlanningGroup } from '@/model/companyStructure/PlanningGroup'
import {
  AddressProjectSpecificationsAuslieferorte, AddressProjectSpecificationsBonitaeten,
  AddressProjectSpecificationsKonditionenZahlung,
  AddressProjectSpecificationsKontoPlan, AddressProjectSpecificationsLieferung,
  AddressProjectSpecificationsPreisarten,
  AddressProjectSpecificationsProfitCenter,
  AddressProjectSpecificationsSteuersaetze,
  AddressProjectSpecificationsUmsatzart, AddressProjectSpecificationsVersand,
  AddressProjectSpecificationsWaehrungen, AdressVorgaben
} from '@/types/service-response'

interface ComponentData {
  rules: Array<Function>
  ProfitCenter: number | null
  Umsatzart: number | null
  Waehrung: number | null
  Versandart: number | null
  Lieferkondition: number | null
  Zahlungskondition: number | null
  Steuer: number | null
  Preisart: number | null
  KonditionsAdresse: number | null
  PreisAdresse: number | null
  AgPgAdresse: number | null
  Sammelkonto: number | null
  Auslieferort: number | null
  FinanzAdresse: string
  FinanzNummer: string
  FinanzCode: string
  Transferiert: boolean | null
  Kreditlimite: number | null //double
  Saldo: number | null //double
  SaldoFW: number | null //double
  IstFW: boolean | null
  Bonitaet: number | null
  SteuerVomProdukt: boolean
}

export default Vue.extend({
  name: 'AddressProjectSpecifications',

  components: { },

  props: {
    show: {
      type: Boolean,
      default: false
    },
    loading: Boolean,
    isEdit: Boolean,
    title: String,
    addressId: Number,
    dialogData: Object as () => AdressVorgaben,
    departmentList: Array as () => Array<Department>,
    allPlanningGroupList: Array as () => Array<PlanningGroup>,
    waehrungList: Array as () => AddressProjectSpecificationsWaehrungen[],
    kontoPlanList: Array as () => AddressProjectSpecificationsKontoPlan[],
    steuersaetzeList: Array as () => AddressProjectSpecificationsSteuersaetze[],
    preisartenList: Array as () => AddressProjectSpecificationsPreisarten[],
    umsatzartList: Array as () => AddressProjectSpecificationsUmsatzart[],
    profitCenterList: Array as () => AddressProjectSpecificationsProfitCenter[],
    konditionenZahlungList: Array as () => AddressProjectSpecificationsKonditionenZahlung[],
    auslieferorteList: Array as () => AddressProjectSpecificationsAuslieferorte[],
    bonitaetenList: Array as () => AddressProjectSpecificationsBonitaeten[],
    versandList: Array as () => AddressProjectSpecificationsVersand[],
    lieferungList: Array as () => AddressProjectSpecificationsLieferung[]
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || ''

    return {
      rules: [required],
      ProfitCenter: null,
      Umsatzart: null,
      Waehrung: null,
      Versandart:null,
      Lieferkondition: null,
      Zahlungskondition: null,
      Steuer: null,
      Preisart: null,
      KonditionsAdresse: null,
      PreisAdresse: null,
      AgPgAdresse: null,
      Sammelkonto: null,
      Auslieferort: null,
      FinanzAdresse: '',
      FinanzNummer: '',
      FinanzCode: '',
      Transferiert: false,
      Kreditlimite: null, //double
      Saldo: null, //double
      SaldoFW: null, //double
      IstFW: false,
      Bonitaet: null,
      SteuerVomProdukt: true
    }
  },

  computed: {
    selectedLanguageId (): number {
      return this.$store.getters[GET_SELECTED_UI_LANGUAGE].syzId
    },

    toolbarColor (): string {
      return hexToRgba(this.$vuetify.theme.themes.light.primary)
    }
  },

  methods: {
    onCloseButtonClick (): void {
      this.$emit('close')
    },

    onCancelButtonClick (): void {
      this.onCloseButtonClick()
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']

      if(form.validate()) {
        if (!this.isEdit) {
          const payload: InsertAdressVorgabenPayload = {
            languageId: this.selectedLanguageId,
            AdressID: this.addressId,
            ProfitCenter: this.ProfitCenter!,
            Umsatzart: this.Umsatzart,
            Waehrung: this.Waehrung,
            Versandart: this.Versandart,
            Lieferkondition: this.Lieferkondition,
            Zahlungskondition: this.Zahlungskondition,
            Steuer: this.Steuer,
            Preisart: this.Preisart,
            KonditionsAdresse: this.KonditionsAdresse,
            PreisAdresse: this.PreisAdresse,
            AgPgAdresse: this.AgPgAdresse,
            Sammelkonto: this.Sammelkonto,
            Auslieferort: this.Auslieferort,
            FinanzAdresse: this.FinanzAdresse,
            FinanzNummer: this.FinanzNummer,
            FinanzCode: this.FinanzCode,
            Transferiert: this.Transferiert,
            Kreditlimite: this.Kreditlimite, //double
            Saldo: this.Saldo, //double
            SaldoFW: this.SaldoFW, //double
            IstFW: this.IstFW,
            Bonitaet: this.Bonitaet,
            SteuerVomProdukt: this.SteuerVomProdukt,
          }
          this.$emit('create', payload)
        } else {
          const payload: UpdateAdressVorgabenPayload = {
            ID: this.dialogData.ID,
            ProfitCenter: this.ProfitCenter!,
            Umsatzart: this.Umsatzart,
            Waehrung: this.Waehrung,
            Versandart: this.Versandart,
            Lieferkondition: this.Lieferkondition,
            Zahlungskondition: this.Zahlungskondition,
            Steuer: this.Steuer,
            Preisart: this.Preisart,
            KonditionsAdresse: this.KonditionsAdresse,
            PreisAdresse: this.PreisAdresse,
            AgPgAdresse: this.AgPgAdresse,
            Sammelkonto: this.Sammelkonto,
            Auslieferort: this.Auslieferort,
            FinanzAdresse: this.FinanzAdresse,
            FinanzNummer: this.FinanzNummer,
            FinanzCode: this.FinanzCode,
            Transferiert: this.Transferiert,
            Kreditlimite: this.Kreditlimite, //double
            Saldo: this.Saldo, //double
            SaldoFW: this.SaldoFW, //double
            IstFW: this.IstFW,
            Bonitaet: this.Bonitaet,
            SteuerVomProdukt: this.SteuerVomProdukt,
          }
          this.$emit('edit', payload)
        }
      }
    },

    setData (): void {
      if(this.dialogData) {
        this.ProfitCenter = this.dialogData.ProfitCenter
        this.Umsatzart = this.dialogData.UmsatzArt
        this.Waehrung = this.dialogData.Waehrung
        this.Versandart = this.dialogData.Versandart
        this.Lieferkondition = this.dialogData.Lieferkondition
        this.Zahlungskondition = this.dialogData.Zahlungskondition
        this.Steuer = this.dialogData.Steuer
        this.Preisart = this.dialogData.Preisart
        this.KonditionsAdresse = this.dialogData.KonditionsAdresse
        this.PreisAdresse = this.dialogData.PreisAdresse
        this.AgPgAdresse = this.dialogData.AgPgAdresse
        this.Sammelkonto = this.dialogData.Sammelkonto
        this.Auslieferort = this.dialogData.Auslieferort
        this.FinanzAdresse = this.dialogData.FinanzAdresse ? this.dialogData.FinanzAdresse : ''
        this.FinanzNummer = this.dialogData.FinanzNummer ? this.dialogData.FinanzNummer : ''
        //this.FinanzCode = this.dialogData.FinanzCode
        this.Transferiert = this.dialogData.Transferiert
        this.Kreditlimite = this.dialogData.Kreditlimite //double
        this.Saldo = this.dialogData.Saldo //double
        this.SaldoFW = this.dialogData.SaldoFW //double
        this.IstFW = this.dialogData.IstFW
        this.Bonitaet = this.dialogData.Bonitaet
        this.SteuerVomProdukt = this.dialogData.SteuerVomProdukt ? this.dialogData.SteuerVomProdukt : false
      }
    }
  },

  mounted (): void {
    if(this.isEdit) {
      this.setData()
    }

    setTimeout(() => {
      const focusedField: any = this.$refs['focusedField']
      if (focusedField) {
        focusedField.focus()
      }
    }, 100)
  }

})
